import React, {
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react';
import { Gender } from '@avaturn/sdk';
import { useMytaverseEvent } from '@core/dashboard/providers';

type EventProviderProps = {
  children: ReactNode;
};

export interface IRecreateAvaturnAvatar {
  avatarId: string;
  avaturnId: string;
  url: string;
  gender: Gender;
}

export interface IEventContext {
  // showAvaturnModal: boolean;
  // setShowAvaturnModal: Dispatch<SetStateAction<boolean>>;
  recreateAvaturnAvatar: IRecreateAvaturnAvatar | null;
  setRecreateAvaturnAvatar: Dispatch<
    SetStateAction<IRecreateAvaturnAvatar | null>
  >;

  isSkyLinkActive: boolean;
  setIsSkyLinkActive: Dispatch<SetStateAction<boolean>>;
}

export const ClientEventContext = React.createContext<IEventContext>(
  {} as IEventContext,
);

export const useClientEventContext = () => useContext(ClientEventContext);

export const EventProvider: React.FC<EventProviderProps> = ({ children }) => {
  const { currentEvent, setSkyLinkExperience } = useMytaverseEvent();

  //const [showAvaturnModal, setShowAvaturnModal] = useState(false);
  const [recreateAvaturnAvatar, setRecreateAvaturnAvatar] =
    useState<IRecreateAvaturnAvatar | null>(null);

  const [isSkyLinkActive, setIsSkyLinkActive] = useState(false);

  useEffect(() => {
    const isA380Event = currentEvent?.eventTags
      ? currentEvent.eventTags.includes('A380')
      : false;
    const params = new URLSearchParams(window.location.search);

    setSkyLinkExperience(
      (params.has('skylink') ? params.get('skylink') === 'true' : false) ||
        isA380Event,
    );
  }, [currentEvent]);

  return (
    <ClientEventContext.Provider
      value={{
        // showAvaturnModal,
        // setShowAvaturnModal,
        recreateAvaturnAvatar,
        setRecreateAvaturnAvatar,

        isSkyLinkActive,
        setIsSkyLinkActive,
      }}
    >
      {children}
    </ClientEventContext.Provider>
  );
};
